// extracted by mini-css-extract-plugin
export default {"audio":"index_audio__hzpcP","audioPlay":"index_audioPlay__tj3Mu"};